import { ApiService, ApiError } from './api.service'
import { Constants } from '../constants'
import {Customer, CustomerService} from './customer.service'
import {Location, LocationService} from './location.service'
import { User } from './user.service'
import XLSX from "xlsx";
import accounts from "@/views/settings/accounts/accounts";
import account from "@/views/settings/account/account";


class AuthenticationError extends Error {
    constructor(code, message) {
        super(message)
        this.name = this.constructor.name
        this.message = message
        this.errorCode = code
    }
}

class CoupledUser {
    constructor(coupledUser) {
        this.firstName = coupledUser ? coupledUser.firstName : undefined
        this.lastName = coupledUser ? coupledUser.lastName : undefined
        this.email = coupledUser ? coupledUser.email : undefined
    }
}

class Account {
    constructor(account) {
        this.id = account ? account.id : undefined
        this.firstName = account ? account.firstName : undefined
        this.lastName = account ? account.lastName : undefined
        this.emailAddress = account ? account.emailAddress : undefined
        this.role = account ? account.role : undefined
        this.customer = account ? account.customer || new Customer() : new Customer()
        this.customers = account ? account.customers : []
        this.users = account ? account.users : []
        this.locations = account && account.locations ? account.locations.map(o => new Location(o)) : []
        this.allowRecurringBooking = account ? account.allowRecurringBooking : false
        this.active = account ? account.active : false
        this.lastSeen = account ? new Date(account.lastSeen) : undefined
        this.registrationMessage = account ? account.registrationMessage : undefined
    }

    getName() {
        return `${this.firstName} ${this.lastName}`
    }

    getLocations() {
        var locations = []

        for (const location of this.locations) {
            locations.push(location.name)
        }

        return locations.length > 0 ? locations.join(', ') : '-'
    }
}

const AccountService = {

    getAccounts: async function() {
        try {
            const response = await ApiService.get(Constants.ENDPOINT_ACCOUNTS)
            return response.data
        }catch(error) {
            throw new ApiError(error)
        }
    },

    getAccount: async function(accountId) {
        try {
            const endpoint = `${Constants.ENDPOINT_ACCOUNTS}/${accountId}`
            const response = await ApiService.get(endpoint)
            return response.data
        }catch(error) {
            throw new ApiError(error)
        }
    },

    getLoggedInAccount: async function() {
        try {
            const endpoint = `${Constants.ENDPOINT_ACCOUNT}`
            const response = await ApiService.get(endpoint)
            return response.data
        }catch(error) {
            throw new ApiError(error)
        }
    },

    updateAccount: async function(account) {
        try {
            const endpoint = `${Constants.ENDPOINT_ACCOUNTS}/${account.id}`
            const response = await ApiService.put(endpoint, account)
            return response
        }catch(error) {
            throw new ApiError(error)
        }
    },

    exportDetails: async function (accounts) {

        const accountsExport = accounts.map((account) => {
            return {
                'Active': account.active ? 'Yes' : 'No',
                'First name': account.firstName,
                'Last name': account.lastName,
                'Email': account.emailAddress,
                'Role': account.role,
                'locations': account.locations?.map((location) => {return location.name}).join(','),
                'customers': account.customers?.map((customer) => {return customer.name}).join(','),
                'Registration message': account.registrationMessage,
                'Last seen': account.lastSeen.getTime() !== 0 ? account.lastSeen : undefined
            }
        })

        try {
            const wb = XLSX.utils.book_new();
            const excel = XLSX.utils.json_to_sheet(accountsExport)
            // Add the excel sheet to the excel file, name the sheet "bookings"
            XLSX.utils.book_append_sheet(wb, excel, "Users");
            // Download the excel file
            XLSX.writeFile(wb, "user_export.xlsx");
        } catch (error) {
            console.error(error)
            throw new ApiError(error)
        }


    },

}

export { AccountService, AuthenticationError, Account, CoupledUser}
